import React from "react";
import TopMenuLevelZero from "../TopMenulLevelZero";
export const MoreMenu = ({ menus, }) => (<TopMenuLevelZero menu={{
        ID: "more",
        Items: menus.map((menu) => ({
            ...menu,
            HasChilds: true,
            SubMenuItems: menu.Items,
            Url: "",
        })),
        Title: "More",
        Type: "TopmenuText",
        Icon: "",
    }}/>);
